import { createApp } from "vue";
import { createPinia } from "pinia";
import VuetifyUseDialog from "vuetify-use-dialog";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import axios from "axios";

// Quill WISYWIG Editor
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

// import "mdi-icons/css/materialdesignicons.min.css";

// Vuetify
import "vuetify/styles";
import "../assets/styles/main.scss";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { en, de } from "vuetify/locale";
import { aliases, mdi } from "vuetify/iconsets/mdi";

import "@/styles/calculations.scss";

import * as Sentry from "@sentry/vue";
import rustWorker from "./plugins/rustWorker";
import { useSocketStore } from "./stores/socketStore";

// Axios defaults
axios.defaults.baseURL = import.meta.env.VITE_BACKEND_URL
  ? import.meta.env.VITE_BACKEND_URL
  : `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
// pinia.use(Sentry.createSentryPiniaPlugin());

const vuetify = createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: "myTheme",
    themes: {
      myTheme: {
        colors: {
          background: "#F5FBFF"
        }
      }
    }
  },
  locale: {
    messages: { en, de }
  },
  defaults: {
    VTextField: {
      density: "compact",
      hideDetails: "auto",
      persistentPlaceholder: true,
      variant: "outlined"
    },
    VCheckbox: {
      density: "compact",
      hideDetails: "auto"
    },
    VSelect: {
      density: "compact",
      hideDetails: "auto",
      persistentPlaceholder: true,
      variant: "outlined"
    },
    VCombobox: {
      density: "compact",
      hideDetails: "auto",
      persistentPlaceholder: true,
      variant: "outlined"
    }
  },
  components,
  directives
});

const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(VuetifyUseDialog);
app.component("QuillEditor", QuillEditor);

app.use(rustWorker);

const socketStore = useSocketStore();

window.onbeforeunload = function (e) {
  console.log("User is leaving the page");
  // e.preventDefault();
  socketStore.socket.disconnect();
  return undefined;
};

Sentry.init({
  app,
  dsn: "https://f956469c14384645cceaddb45a825958@o4509280625754112.ingest.de.sentry.io/4510187283873872",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration({ router })],
  environment: window.location.hostname
});

i18n(app).mount("#app");
